import { CircularProgress } from "../CircularProgress";
import { RefreshIcon } from "../Icon";
import { IconButton, IconButtonProps } from "../IconButton";
export type RefreshButtonProps = Omit<IconButtonProps, "children" | "color" | "title" | "aria-label"> & {
  loading?: boolean;
};

export const RefreshButton = ({ variant = "filled", loading = false, ...props }: RefreshButtonProps) => (
  <IconButton
    variant={variant}
    color={variant === "subtle" ? "secondary" : "weak"}
    title="再読み込みする"
    aria-label="再読み込みする"
    {...props}
  >
    {loading ? <CircularProgress /> : <RefreshIcon />}
  </IconButton>
);
